module.exports = "<p>\r\n  multiple-offers works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authentication/components/multiple-offers/multiple-offers.component.html
// module id = ./src/app/authentication/components/multiple-offers/multiple-offers.component.html
// module chunks = main